<template>
  <div>
    <el-table :data="fundsData" size="mini" :resizable="false" :row-style="rowStyle">
      <el-table-column v-if="!hideAction" label="操作" width="70px">
        <template slot-scope="scope">
          <el-button :disabled="!!scope.row.天天基金经理ID" size="mini" type="text" @click="handleMark(scope.row)">{{
            scope.row.isMain ? '取消主管' : '标为主管'
          }}</el-button>
        </template>
      </el-table-column>
      <el-table-column label="基金名称" width="120px">
        <template slot-scope="scope">
          <div class="radish-btn-text" @click="showChart(scope.row)">{{ scope.row.name }}</div>
        </template>
      </el-table-column>
      <el-table-column label="基金代码" prop="_qutkeId" width="90px"></el-table-column>
      <el-table-column label="基金类型">
        <template slot-scope="scope">
          {{ scope.row.wandeCategory || scope.row.fundNature }}
        </template>
      </el-table-column>
      <el-table-column label="任职期" width="100px">
        <template slot-scope="scope">
          {{ formateRenzhi(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column label="累计收益" width="70px">
        <template slot-scope="scope">
          {{ percent(scope.row.manager.cucmulativeReturn) }}
        </template>
      </el-table-column>
      <el-table-column label="年化收益" width="70px">
        <template slot-scope="scope">
          {{ percent(scope.row.manager.yearReturn) }}
        </template>
      </el-table-column>
      <el-table-column label="最大回撤" width="70px">
        <template slot-scope="scope">
          {{ percent(scope.row.manager.maxDrawdown) }}
        </template>
      </el-table-column>
      <el-table-column label="波动性" width="70px">
        <template slot-scope="scope">
          {{ percent(scope.row.manager.vol) }}
        </template>
      </el-table-column>
    </el-table>
    <FundChart ref="FundChart" />
  </div>
</template>
<script>
import FundChart from './fund-chart'

export default {
  components: { FundChart },
  props: {
    rid: { type: String, default: '' },
    funds: { type: Array, default: [] },
    hideAction: { type: Boolean, default: false },
  },
  data() {
    return {
      dialogVisible: false,
      fundsData: [],
    }
  },
  async created() {
    this.fundsData = JSON.parse(JSON.stringify(this.funds))
  },
  methods: {
    rowStyle(params) {
      const { row, rowIndex } = params
      if (row.isMain) {
        return { backgroundColor: '#f5f7fa' }
      }
    },
    formateRenzhi(row) {
      return `${row.manager.startDate ? row.manager.startDate.substr(0, 10) : '- '}至${this.getEndDateStr(
        row.manager.endDate,
      )}`
    },
    getEndDateStr(date) {
      if (!date || !Date.parse(date)) {
        return ' -'
      }
      const nowTime = new Date().getTime()
      const dateTime = new Date(date).getTime()
      if (nowTime - dateTime <= 5 * 24 * 60 * 60 * 1000) {
        return '今'
      } else {
        return date.substr(0, 10)
      }
    },
    percent(num) {
      if (isNaN(num)) return '-'
      return `${(num * 100).toFixed(2)}%`
    },
    showChart(row) {
      this.$refs.FundChart.open(row)
    },
    async handleMark(row) {
      const mainFunds = []
      this.fundsData = this.fundsData.map(f => {
        if ((f._id && row._id && f._id === row._id) || (f._qutkeId && row._qutkeId && f._qutkeId === row._qutkeId)) {
          f.isMain = !f.isMain
        }
        if (f.isMain) {
          mainFunds.push(f._qutkeId)
        }
        return f
      })
      const res = await app.service('radish').modifyById({ _id: this.rid, data: { 主管基金: mainFunds } })
      if (res.status === 'success') {
        this.$parent.$parent.mainFunds = mainFunds
      } else {
        this.$message.error(res.msg)
      }
    },
  },
}
</script>
<style>
.fund-list {
  position: fixed;
  top: 20%;
  left: 40%;
  right: 10%;
  padding: 10px;
  background: #fff;
  border-radius: 2px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  z-index: 1005;
}
.fund-list-title {
  position: relative;
  padding: 10px;
  line-height: 24px;
  font-size: 18px;
  color: #303133;
}
.fund-close {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}
.fund-list-body {
  max-height: 50vh;
  overflow: auto;
}
</style>
